<template>
    <div>
        <design-2021-apprentice-data-table
            class="yearbooks-overview"
            v-if="magazines.length"
            :fields="yearbooksTableFields"
            :items="magazines">
            <template #options>
                <b-form-select
                    class="float-right"
                    v-model="selected"
                    @change="deadlineChange">
                    <option
                        v-for="deadline in deadlines"
                        v-if="deadline.agenda_item"
                        :value="deadline.id">
                        {{ deadline.agenda_item.date }}
                    </option>
                    <option :value="0">{{ $t('magazine.exceptions') }}</option>
                    <option :value="-1">{{ $t('magazine.without_deadline') }}</option>
                </b-form-select>

                <b-button
                    class="btn btn-primary btn-download-list"
                    variant="link"
                    href=""
                    :href="routes.baseUrl() + '/magazine/downloadmagazines/' + selected">
                    {{ $t('magazine.download_list') }}
                </b-button>
            </template>

            <template #cell(school_id)="data">
                <span class="page_size">
                    {{ data.value }}
                </span>
            </template>

            <template #cell(page_size)="row">
                <span class="page_size">
                    {{ row.item.size.title }}
                </span>
            </template>

            <template #cell(pages)="row">
                <div class="pages">
                    <div
                        class="float-left"
                        style="width: 50px; height: 100%; text-align: center">
                        {{ row.item.num_pages }}
                    </div>
                    <div
                        class="float-left"
                        style="width: 10px; text-align: center">
                        |
                    </div>
                    <div
                        class="float-left"
                        style="width: 50px; height: 100%; text-align: center">
                        {{ row.item.approved_pages_count }}
                    </div>
                </div>
            </template>

            <template #cell(last_edited)="row">
                <span class="last_edited">
                    {{ row.item.last_edited.lastEdited }}
                </span>
            </template>

            <template #cell(status)="row">
                <span
                    class="status"
                    v-if="row.status && row.status.length > 0">
                    {{ row.item.status[0].status }}
                </span>
            </template>

            <template #cell(actions)="row">
                <b-button
                    class="btn-clean btn-select"
                    variant="inverse-primary"
                    @click="onSelect(row.item.school_id, row.item.id)"
                    :title="$t('common.open')">
                    <i class="fas fa-folder-open fa-fw"></i>
                </b-button>
                <b-button
                    class="btn-clean btn-check"
                    v-if="
                        row.item.status &&
                        row.item.status.length > 0 &&
                        (row.item.status[0].status == 'Verwerkt' ||
                            row.item.status[0].status == 'Afgekeurd' ||
                            row.item.status[0].status == 'Akkoord' ||
                            row.item.status[0].status == 'JPG verwerkt')
                    "
                    variant="inverse-primary"
                    @click="onCheck(row.item.id)"
                    :title="$t('magazine.check')">
                    <i class="fa fa-check fa-fw"></i>
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="yearbooks-not-found"
            v-else>
            <div class="yearbook-type-select">
                <b-form-select
                    class="float-right"
                    v-model="selected"
                    @change="deadlineChange">
                    <option
                        v-for="deadline in deadlines"
                        v-if="deadline.agenda_item"
                        :value="deadline.id">
                        {{ deadline.agenda_item.date }}
                    </option>
                    <option :value="0">{{ $t('magazine.exceptions') }}</option>
                    <option :value="-1">{{ $t('magazine.without_deadline') }}</option>
                </b-form-select>
            </div>

            <div class="notice">
                <b-alert
                    variant="warning"
                    show
                    >{{ $t('magazine.no_magazines_found') }}</b-alert
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-magazines-component',
    props: ['magazinesIn', 'deadlinesIn', 'deadlineIn'],
    data() {
        var selected = null;
        if (this.deadlineIn !== null || this.deadlinesIn.length > 0) {
            selected = this.deadlineIn ? this.deadlineIn : this.deadlinesIn[0].id;
        }

        return {
            selected: selected,
            deadlines: this.deadlinesIn,
            magazines: this.magazinesIn,
            yearbooksTableFields: [
                {
                    key: 'school_id',
                    label: 'ID',
                },
                {
                    key: 'title',
                    label: 'Titel',
                },
                {
                    key: 'pages',
                    label: this.$t('magazine.pages_ready'),
                },
                {
                    key: 'last_edited',
                    label: this.$t('magazine.last_edited'),
                },
                {
                    key: 'version',
                    label: this.$t('magazine.format_type'),
                },
                {
                    key: 'page_size',
                    label: this.$t('magazine.format'),
                },
                {
                    key: 'printer',
                    label: this.$t('magazine.printer'),
                },
                {
                    key: 'status',
                    label: 'Status',
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            magazinesTableColumns: [
                'school_id',
                'title',
                'pages',
                'last_edited',
                'version',
                'page_size',
                'printer',
                'status',
                'actions',
            ],
            magazinesTableOptions: {
                headings: {
                    school_id: 'ID',
                    title: this.$t('common.title'),
                    pages: this.$t('magazine.pages_ready'),
                    last_edited: this.$t('magazine.last_edited'),
                    version: this.$t('magazine.format_type'),
                    page_size: this.$t('magazine.format'),
                    printer: this.$t('magazine.printer'),
                    status: 'Status',
                    actions: this.$t('common.actions'),
                },
            },
        };
    },
    methods: {
        deadlineChange() {
            window.location.href = this.routes.baseUrl() + '/magazine/magazines/' + this.selected;
        },
        onSelect(school_id, id) {
            window.location.href = this.routes.baseUrl() + '/magazine/open/' + school_id + '/' + id;
        },
        onCheck(id) {
            window.location.href = this.routes.baseUrl() + '/magazine/' + id + '/check/' + this.selected;
        },
        reloadTable() {
            this.$refs.table.refresh();
        },
    },
};
</script>

<style scoped>
.yearbooks-overview >>> table tbody td {
    white-space: normal;
}

.btn-download-list {
    color: #fff;
}

.yearbooks-overview >>> .apprentice-table-call-to-actions select {
    margin-bottom: 15px;
}

.yearbooks-not-found {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-content: flex-end;
}

.yearbook-type-select select {
    margin-right: 0;
    margin-bottom: 15px;
}

@media (min-width: 576px) {
    .yearbook-type-select select {
        width: auto;
    }

    .yearbooks-overview >>> .apprentice-table-call-to-actions select {
        margin-bottom: 0;
        margin-right: 15px;
        width: auto;
    }
}
</style>
